<template>
  <div class="wrap join-wrap">
    <Loading :visible="isLoadingPop"></Loading>
    <div class="join-form">
      <div class="title-txt">
        <h3>Bnb가 처음이시군요!</h3>
        <p>
          <!-- Bnb가 처음이시군요! <br> -->
          아래 간단한 정보를 입력하시면 <br />
          바로 시작할 수 있습니다.
        </p>
      </div>
      <ul>
        <li class="mb-30">
          <input type="text" placeholder="이름을 입력해 주세요." v-model="input.userName" @keyup="Keyupevent" />
        </li>
        <li class="mb-30">
          <input type="text" placeholder="연락처를 입력해 주세요." v-model="handphone" @keyup="phoneKeyUp" />
        </li>
        <li>
          <input type="password" placeholder="비밀번호를 입력해 주세요" v-model="input.password" @keyup="Keyupevent" />
        </li>
        <!-- v-if="isPassword" -->
        <p class="txt-red">영문+숫자+특수문자 8자리 이상으로 입력해 주세요.</p>
        <li :class="{ 'mb-30': !isPasswordChk }">
          <input type="password" placeholder="비밀번호를 입력해 주세요" v-model="input.passwordChk" @keyup="Keyupevent" />
        </li>
        <!-- 비밀번호가 틀렸을 경우 -->
        <p class="txt-red" v-if="isPasswordChk">동일한 비밀번호를 입력해 주세요.</p>
      </ul>
      <div class="user-agree-wrap">
        <div class="user-agree">
          <label><input type="checkbox" name="" id="" v-model="privacy" /></label>
          <span @click="showPrivacy()">개인정보 이용 및 수집 동의 (필수)</span>
        </div>
        <div class="user-agree">
          <label><input type="checkbox" name="" id="" v-model="privacyMember" /> <span>회원 이용약관 동의 (필수)</span></label>
        </div>
      </div>
    </div>

    <div class="bnb-btn">
      <!-- 입력 시 class="active" 활성화 -->
      <button @click="join()" :class="{ active: isActive }">로그인</button>
    </div>
    <privacy :visible="isPrivacyPop" @close="popClose"></privacy>
  </div>
</template>
<script>
import { EmptyCheck, PWFormatCheck, PhoneFormatCheck } from "@/utils/validation";
import privacy from "@/page/privacy.vue";
import Loading from "@/components/inc/inc_loading.vue";
export default {
  name: "join",
  props: {
    email: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    input: {
      userName: "",
      userHandphone: "",
      userId: "",
      password: "",
      passwordChk: "",
      courseIdx: 0,
    },
    handphone: "",
    isActive: false,
    isPassword: false,
    isPasswordChk: false,
    privacy: false,
    privacyMember: false,
    isPrivacyPop: false,
    isLoadingPop: false,
  }),
  components: {
    privacy,
    Loading,
  },

  methods: {
    phoneKeyUp() {
      let handphone = this.handphone.replace(/[^0-9]/g, "");
      this.handphone = handphone.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3");
    },
    popClose() {
      this.isPrivacyPop = false;
    },
    showPrivacy() {
      let app_el = document.getElementById("app");
      app_el.style.overflow = "scroll";
      this.isPrivacyPop = true;
      // this.$router.push("/privacy");
    },
    Keyupevent() {
      // if(this.input.userHandphone != ""){
      //     this.input.userHandphone = this.input.userHandphone.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
      // }
      if (this.input.userName != "" && this.handphone != "" && this.input.password != "" && this.input.passwordChk != "") {
        this.isActive = true;
      }
    },
    join() {
      if (this.isActive) {
        this.input.courseIdx = this.$store.state.courseInfo.courseIdx;
        this.input.userId = this.$store.state.courseInfo.userId;

        if (!EmptyCheck(this.input.userName, "이름을")) {
          return false;
        }
        if (!EmptyCheck(this.handphone, "연락처를")) {
          return false;
        }

        if (!PhoneFormatCheck(this.handphone)) {
          return false;
        }

        // eslint-disable-next-line
        var reg = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi;
        this.input.userHandphone = this.handphone.replace(reg, "");

        if (!PWFormatCheck(this.input.password)) {
          this.isPassword = true;
          return false;
        } else {
          this.isPassword = false;
        }
        if (this.input.password != this.input.passwordChk) {
          this.isPasswordChk = true;
          return false;
        } else {
          this.isPasswordChk = false;
        }
        if (!this.privacy) {
          alert("개인정보 이용 및 수집을 동의해주세요.");
          return false;
        }
        if (!this.privacyMember) {
          alert("회원 이용약관을 동의해주세요.");
          return false;
        }

        this.isLoadingPop = true;

        let params = this.input;
        this.axios
          .post("/auth/user-join", params)
          .then((res) => {
            if (res.data.success) {
              this.$store.commit("setCourseUserIdx", res.data.contentinfo.userIdx);
              this.login();
            } else {
              alert("회원가입 실패");
              this.isLoadingPop = false;
            }
          })
          .catch((err) => {
            this.isLoadingPop = false;
          });
      } else {
        alert("빈칸을 입력해주세요.");
        return false;
      }
    },
    login() {
      localStorage.setItem("accessToken", null);
      let params = {
        courseAccesscode: this.$store.state.courseInfo.accessCode,
        userId: this.$store.state.courseInfo.userId,
        password: this.input.password,
        deviceId: "",
      };
      params.deviceId = localStorage.getItem("fcmtoken");
      this.axios
        .post("/auth/user-login", params)
        .then((res) => {
          if (res.data.success) {
            localStorage.setItem("accessToken", res.data.contentinfo.access_token);
            let userInfo = {
              accessCode: this.$store.state.courseInfo.accessCode,
              userId: this.$store.state.courseInfo.userId,
              pass: this.$store.state.courseInfo.pass,
              courseIdx: this.$store.state.courseInfo.courseIdx,
              courseCategoryLimit: this.$store.state.courseInfo.courseCategoryLimit,
              courseEmbeddedSurvey: this.$store.state.courseInfo.courseEmbeddedSurvey,
              userIdx: res.data.contentinfo.userInfo.userIdx,
              userName: res.data.contentinfo.userInfo.username,
              coarching: res.data.contentinfo.coarchingList,
            };

            this.$store.commit("setRebbokEmbedded", false);
            this.$store.commit("setUserInfo", userInfo);
            this.$store.commit("setUserIdx", res.data.contentinfo.userInfo.userIdx);
            this.isLoadingPop = false;
            if (
              this.$store.state.courseInfo.courseCategoryLimit == "1" ||
              this.$store.state.courseInfo.courseCategoryLimit == "N"
            ) {
              if (this.$store.state.courseInfo.courseEmbeddedSurvey == "Y") {
                if (localStorage.getItem("isEmbedded") == "1") {
                  this.$router.push({ name: "embedded_survey_result", params: { view: 0 } });
                } else {
                  this.$router.push("embedded_survey");
                }
              } else {
                this.$router.push({ name: "reserve_subject_sub" });
              }
            } else {
              this.$router.push({ name: "reserve_subject_sub" });
            }
          } else {
            alert("로그인 실패");
            this.isLoadingPop = false;
            return false;
          }
        })
        .catch((err) => {
          this.isLoadingPop = false;
          console.log(err);
        });
    },
  },
};
</script>
